module.exports = __webpack_public_path__ + "img/16m002-09.fa914e8a.png";